/**
 * US state code <-> name <-> slug — mirror of `backend/services/us_states.py`
 * so frontend hub pages can decode `/instructors/california` etc.
 */

export const US_STATES = [
  ['AL', 'Alabama', 'alabama'],
  ['AK', 'Alaska', 'alaska'],
  ['AZ', 'Arizona', 'arizona'],
  ['AR', 'Arkansas', 'arkansas'],
  ['CA', 'California', 'california'],
  ['CO', 'Colorado', 'colorado'],
  ['CT', 'Connecticut', 'connecticut'],
  ['DE', 'Delaware', 'delaware'],
  ['DC', 'District of Columbia', 'district-of-columbia'],
  ['FL', 'Florida', 'florida'],
  ['GA', 'Georgia', 'georgia'],
  ['HI', 'Hawaii', 'hawaii'],
  ['ID', 'Idaho', 'idaho'],
  ['IL', 'Illinois', 'illinois'],
  ['IN', 'Indiana', 'indiana'],
  ['IA', 'Iowa', 'iowa'],
  ['KS', 'Kansas', 'kansas'],
  ['KY', 'Kentucky', 'kentucky'],
  ['LA', 'Louisiana', 'louisiana'],
  ['ME', 'Maine', 'maine'],
  ['MD', 'Maryland', 'maryland'],
  ['MA', 'Massachusetts', 'massachusetts'],
  ['MI', 'Michigan', 'michigan'],
  ['MN', 'Minnesota', 'minnesota'],
  ['MS', 'Mississippi', 'mississippi'],
  ['MO', 'Missouri', 'missouri'],
  ['MT', 'Montana', 'montana'],
  ['NE', 'Nebraska', 'nebraska'],
  ['NV', 'Nevada', 'nevada'],
  ['NH', 'New Hampshire', 'new-hampshire'],
  ['NJ', 'New Jersey', 'new-jersey'],
  ['NM', 'New Mexico', 'new-mexico'],
  ['NY', 'New York', 'new-york'],
  ['NC', 'North Carolina', 'north-carolina'],
  ['ND', 'North Dakota', 'north-dakota'],
  ['OH', 'Ohio', 'ohio'],
  ['OK', 'Oklahoma', 'oklahoma'],
  ['OR', 'Oregon', 'oregon'],
  ['PA', 'Pennsylvania', 'pennsylvania'],
  ['RI', 'Rhode Island', 'rhode-island'],
  ['SC', 'South Carolina', 'south-carolina'],
  ['SD', 'South Dakota', 'south-dakota'],
  ['TN', 'Tennessee', 'tennessee'],
  ['TX', 'Texas', 'texas'],
  ['UT', 'Utah', 'utah'],
  ['VT', 'Vermont', 'vermont'],
  ['VA', 'Virginia', 'virginia'],
  ['WA', 'Washington', 'washington'],
  ['WV', 'West Virginia', 'west-virginia'],
  ['WI', 'Wisconsin', 'wisconsin'],
  ['WY', 'Wyoming', 'wyoming'],
];

const SLUG_TO = {};
const CODE_TO = {};
for (const [code, name, slug] of US_STATES) {
  SLUG_TO[slug] = { code, name, slug };
  CODE_TO[code] = { code, name, slug };
}

/**
 * Resolve any state input (slug like "california", 2-letter code like
 * "CA"/"ca", or full name like "California") to `{ code, name, slug }`,
 * or null if no match.
 */
export function resolveState(input) {
  if (!input || typeof input !== 'string') return null;
  const v = input.trim().toLowerCase();
  if (SLUG_TO[v]) return SLUG_TO[v];
  const upper = input.trim().toUpperCase();
  if (CODE_TO[upper]) return CODE_TO[upper];
  for (const [code, name, slug] of US_STATES) {
    if (name.toLowerCase() === v) return { code, name, slug };
  }
  return null;
}
